const KEY = 'ggpc_device_uid';

function leerCookie(nombre) {
    try {
          const partes = document.cookie.split(';');
          for (let i = 0; i < partes.length; i++) {
                  const p = partes[i].trim();
                  if (p.indexOf(nombre + '=') === 0) {
                            return decodeURIComponent(p.substring(nombre.length + 1));
                  }
          }
    } catch (e) {}
    return null;
}

function escribirCookie(nombre, valor) {
    try {
          const maxAge = 60 * 60 * 24 * 365 * 5;
          document.cookie = nombre + '=' + encodeURIComponent(valor) + '; path=/; max-age=' + maxAge + '; SameSite=Lax';
    } catch (e) {}
}

function leerLocal() {
    try {
          return localStorage.getItem(KEY);
    } catch (e) {
          return null;
    }
}

function escribirLocal(valor) {
    try {
          localStorage.setItem(KEY, valor);
    } catch (e) {}
}

export function getDeviceUid() {
    let id = leerLocal() || leerCookie(KEY);
    if (!id) {
          id = 'dev-' + Math.random().toString(36).slice(2) + '-' + Date.now().toString(36);
    }
    escribirLocal(id);
    escribirCookie(KEY, id);
    return id;
}

export async function registerDevice() {
    const deviceUid = getDeviceUid();
    try {
          const res = await fetch('/api/devices', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ deviceUid, userAgent: navigator.userAgent }) });
          const data = await res.json();
          return data.device || null;
    } catch (err) {
          console.error('No se pudo registrar el dispositivo', err);
          return null;
    }
}
